import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  Tooltip,
  MenuItem,
  AppBar,
  Toolbar,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { getData } from "../../../../../services/library";
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AltaChoferZona from "./alta/AltaChoferZona";
import MarcarActivoChofer from "./activo/MarcarActivoChofer";
import BajaChoferZona from "./baja/BajaChoferZona";
import { Delete } from "@mui/icons-material";

function ChoferZona(props) {
  const [dataZona, setDataZona] = useState(props.dataZona)
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [baja, setBaja] = useState(false); //Abre formulario
  const [tabla, setTabla] = useState(true)
  const [dataRow, setDataRow] = useState()
  const [marcarActivo, setMarcarActivo] = useState(false);
  const [choferesZona, setChoferesZona] = useState()
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);

  
  const obtenerChoferesZonaInactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/envasado_chofer_zona/xzonainactivo/"+props.dataZona.id, setChoferesZona)
  };
    
  //Funcion para traer los clientes a la tabla TODOS :ACTIVOS E INACTIVOS
  const obtenerChoferesZona = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/envasado_chofer_zona/xzonaactivo/"+props.dataZona.id, setChoferesZona)
  };
  
  useEffect(() => {
    obtenerChoferesZona()
  }, [])

  const handleClose = () => {
    props.onClose(false);
    // props.setNotify({ open: false });
  };

  const handleClickNuevo = () => {
    setAlta(true); //pongo alta en true para q muestre el componente Addcliente
  };

  const handleCloseAlta = () => {
    setAlta(false)
    obtenerChoferesZona()
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "nombre_chofer", //access nested data with dot notation
        header: "Chofer",
        maxSize: 100,
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  
  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
  };


  return (
    <div>
    {tabla &&
    <>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: "#0979b0" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={()=>handleClose()}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Choferes de la Zona: {props.dataZona.nombre}
          </Typography>
        </Toolbar>
      </AppBar>
      <MaterialReactTable 
      localization={MRT_Localization_ES}
      columns={columns}
      data={ choferesZona ?? [{}]}
      layoutMode={"grid"}
      initialState={initialState}
      enableColumnActions={false} //deshabilita las acciones POR COLUMNA
      enableGlobalFilterModes={false}
      enableHiding={false}
      enableRowActions={true}
      enableColumnFilters={false}
      enableFullScreenToggle={false}
      positionActionsColumn={"last"}
      enableExpandAll={false}
      enableToolbarInternalActions={true}
      muiTableHeadCellProps={tableHeadCellProps}
      muiSearchTextFieldProps={muiSearchTextFieldProps}
      enableDensityToggle={false}
      displayColumnDefOptions={displayColumnDefOptions}
      enableColumnResizing={ true}
      muiTableBodyCellProps={({ row }) => ({
        align: "left",
        sx: {
          backgroundColor: row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
          color: "black",
        },
      })}
      renderTopToolbarCustomActions={(row, table) => (
        <>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddBoxTwoToneIcon color="asd" />}
            onClick={handleClickNuevo}
          >
            Agregar Chofer
          </Button>
        </>
      )}
      renderToolbarInternalActions={() => (
        <>
          {!hiddenmuestrainactivo ? (
            <Tooltip title="Muestra Inactivos">
              <IconButton
                onClick={() => obtenerChoferesZonaInactivos()}
                color="error"
              >
                <BlockIcon />
              </IconButton>
            </Tooltip>
          ) : null}
          {!hiddenmuestraactivos ? (
            <Tooltip title="Mostrar ACTIVOS" color="success">
              <IconButton onClick={() => obtenerChoferesZona()}>
                <CheckCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          ) : null}
        </>
      )}
      renderRowActionMenuItems={({ closeMenu, row, index }) => [
        <MenuItem
          key={index}
          style={{
            display: row.original.activo === 0 ? null : "none",
          }}
          disabled={row.original.activo === 1}
          onClick={() => {
            setMarcarActivo(true);
            setDataRow(row.original);
            closeMenu();
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <CheckCircleOutlineIcon color="success" />
          </ListItemIcon>
          Marcar Activo
        </MenuItem>,
  
        <MenuItem
          key={index}
          style={{
            display: row.original.activo === 0 ? "none" : null,
          }}
          disabled={row.original.activo === 0}
          onClick={() => {
            closeMenu();
            setDataRow(row.original);
            setBaja(true);
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete color="error" />
          </ListItemIcon>
          Marcar Inactivo
        </MenuItem>,
      ]}
      />
      </>}
      {alta?
      <AltaChoferZona
      alta={alta}
      zona={dataZona}
      onClose={() => handleCloseAlta(false)}
      />
      :null}
      {marcarActivo?
      <MarcarActivoChofer
        open={marcarActivo}
        setOpen={setMarcarActivo}
        chofer={dataRow}
        tabla={setTabla}
        actualizar={obtenerChoferesZona}
      />
      :null}
      {baja && (
        <BajaChoferZona
          open={baja}
          setOpen={setBaja}
          chofer={dataRow}
          tabla={setTabla}
          actualizar={obtenerChoferesZona}
        />
      )}
    </div>
  )
}

export default ChoferZona